import axios from 'axios';
import { KeywordBatchModel } from '../Models/KeywordBatchModel';

const getKeywordBatch = (batch: KeywordBatchModel) => axios.post(`classifications/categories/${batch.categoriesId[0]}/keywords`, batch);
const getKeywordsByClient = (batch: KeywordBatchModel, clientId: number) => axios.post(`classifications/categories/${batch.categoriesId[0]}/keywords/${clientId}`, batch);
const updateKeywordBatch = (batch: KeywordBatchModel) => axios.post(`classifications/categories/${batch.categoriesId[0]}/keywords/update-batch`, batch);

export default {
    getKeywordBatch,
    getKeywordsByClient,
    updateKeywordBatch
};